import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import LionEditor from "./components/Editor";
import NavigationWrapper from "./components/Navigation/NavigationWrapper";
import { defaultValue } from "./data/defaultValue";
var App = function () {
    var saveContent = function (content) {
        console.log(content);
    };
    var initialValue = useMemo(function () {
        var localStorageContent = localStorage.getItem("content");
        var data = localStorageContent
            ? JSON.parse(localStorageContent)
            : defaultValue;
        return data;
    }, []);
    return (_jsxs("div", { children: [_jsx(NavigationWrapper, {}), _jsx(LionEditor, { onSaveContent: saveContent, DefaultContent: initialValue })] }));
};
export default App;
